<template>
    <!-- Adventurer's fedora, flat white; the hat band takes the team colour. -->
    <svg class="theme-rider rider-adventure" :class="{ 'rider-moving': moving }" viewBox="0 4 64 27" :width="size" :height="size * 27 / 64" aria-hidden="true">
        <g class="rider-body">
            <path class="rider-crown" d="M18.5 25 L20.5 11.5 Q21 7 26 6.5 Q29.5 9.5 32 9.5 Q34.5 9.5 38 6.5 Q43 7 43.5 11.5 L45.5 25 Z" />
            <path class="rider-dent" d="M24 9.5 Q32 15 40 9.5" />
            <path class="rider-band-edge" d="M18.6 19.3 L45.4 19.3 L46 25 L18 25 Z" />
            <path class="rider-band" :style="{ fill: color }" d="M19 19.8 L45 19.8 L45.6 24.6 L18.4 24.6 Z" />
            <path class="rider-brim" d="M3.5 26.5 Q8 23.2 18 24 L46 24 Q56 23.2 60.5 26.5 Q55 30.5 47 29.2 Q32 27.4 17 29.2 Q9 30.5 3.5 26.5 Z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'AdventureRider',
    props: {
        color: { type: String, default: '#00a7af' },
        size: { type: Number, default: 56 },
        moving: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
    svg{ overflow: visible; }
    .rider-crown,
    .rider-brim{ fill: #fff; }
    .rider-dent{ fill: none; stroke: rgba(0, 0, 0, 0.25); stroke-width: 1.4; stroke-linecap: round; }
    .rider-band-edge{ fill: rgba(0, 0, 0, 0.45); }
    .rider-body{ transform-origin: 32px 30px; }
    .rider-moving .rider-body{ animation: rider-hop 0.45s ease-in-out infinite alternate; }
    @keyframes rider-hop{ to{ transform: translateY(-3px) rotate(-4deg); } }
    @media (prefers-reduced-motion: reduce){
        .rider-moving .rider-body{ animation: none; }
    }
</style>
